const ENV = {
  LICENSE_KEY: process.env.REACT_APP_CK_EDITOR_LICENSE_KEY,
}

export default ENV
